// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LehM","input":"styles_input__G5_ku"};